import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { RuleType } from '../../IRule.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';

const fieldName = `rules.${RuleType.TotalDigits}`;

export interface ITotalDigitsRuleComponentProps {}

export function TotalDigitsRuleComponent(
  props: ITotalDigitsRuleComponentProps,
) {
  return (
    <FormItem name={`${fieldName}.value`} label="Numero massimo di cifre">
      <$SpaceCompact block size="large">
        <NumberInput name={`${fieldName}.value`} />
        <CustomValidationRuleMessage name={`${fieldName}.customMessage`} />
      </$SpaceCompact>
    </FormItem>
  );
}
